<!-- <div class=""> -->
<div class="row-flex">
  <div class="e5-border-right side-nav-top" [ngClass]="{
      'background-menu-bridge': userType === 'Bridge+',
      'background-menu-parkite': userType !== 'Bridge+'
    }">
    <!-- <div class="profile-image-margin" (click)="profileClick()"> -->
    <div class="profile-image-margin" (click)="profileClick()">
      <div [ngClass]="{ rectangle: selectedIndex == 11, '': selectedIndex != 11 }"></div>
      <img src="/assets/images/Group.png" class="profile-image" alt="Capitaland Image"
        *ngIf="adminData?.image !== undefined && adminData?.image !== null" loading="lazy" />
      <div class="profile-image-letter" *ngIf="
          adminData?.image == undefined ||
          adminData?.image == null ||
          adminData?.image == ''
        ">
        <span>{{ initials }}</span>
      </div>
    </div>

    <!-- <div *ngFor="
        let item of allSideNav | slice : 0 : defaultListCount;
        let i = index
      ">
      <div class="sidenav-margin link" *ngIf="item.sub.length == 0" (click)="selectNav(item, 0, true); toggle('close')">
        <div class="sidenav-box" [ngClass]="{
            'menu-onload': selectedIndex != i,
            'menu-selected': selectedIndex == i
          }">
          <img [src]="selectedIndex == i ? item.selectedImage : item.image" class="" loading="lazy" />
          {{ item?.name }}
        </div>
        <div class="rectangle" *ngIf="selectedIndex == i"></div>
      </div>

      <div [ngClass]="
          !expandVMS || !expandLandscaping
            ? 'link sidenav-margin'
            : 'sub-link pt-1 pb-2'
        " *ngIf="item.sub.length != 0">
        <div (click)="toggle('toggle'); selectNav(item, 0, true); hideShowNav(i)" [ngClass]="{
            'menu-onload': selectedIndex != i,
            'menu-selected-sub': selectedIndex == i
          }" class="sidenav-box">
          <img [src]="selectedIndex == i ? item.selectedImage : item.image" class="" loading="lazy" />
          <p class="mb-3">{{ item.name }}</p>
        </div>

        <div class="link" *ngIf="expandVMS && i == 1">
          <div *ngFor="let sub of item.sub; let j = index">
            <div (click)="selectNav(item, j, true)" [ngClass]="{
                'menu-onload': subIndex != j,
                'menu-selected': subIndex == j
              }">
              <div class="verticleLine"></div>
              {{ sub?.name }}
              <div class="sub-rectangle" *ngIf="subIndex == j"></div>
            </div>
          </div>
        </div>

        <div class="link" *ngIf="expandLandscaping && i == 2">
          <div *ngFor="let sub of item.sub; let j = index">
            <div (click)="selectNav(item, j, true)" [ngClass]="{
                'menu-onload': subIndex != j,
                'menu-selected': subIndex == j
              }">
              <div class="verticleLine"></div>
              {{ sub?.name }}
              <div class="sub-rectangle" *ngIf="subIndex == j"></div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- <div class="sidenav-margin link more" #viewMore (click)="seeLess = false; defaultListCount = allSideNav.length"
      *ngIf="seeLess">
      <div class="sidenav-box">
        <div class="dot-more">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
        More
      </div>
    </div> -->

    <ul class="sidebar_menu">
      <li *ngFor="let item of allSideNav | slice : 0 : defaultListCount"
        [ngClass]="{ 'has-children': item.sub, 'opened': item.expanded }">
        <a [routerLink]="item.link ? item.link: null" [routerLinkActive]="'active'" (click)="toggleSubMenu(item)">
          <div *ngIf="item.image.endsWith('.png'); else svgIcon">
            <img [src]="!item.expanded ? item.image : item.selectedImage" [alt]="item.name">
          </div>
          <ng-template #svgIcon>
            <svg-icon [src]="item.image"></svg-icon>
          </ng-template>
          {{ item.name }}
          <!-- <i class="material-icons" *ngIf="item.sub">{{ item.expanded ? "expand_less" : "expand_more" }}</i> -->
        </a>
        <ul [ngClass]="{ 'show-submenu': item.expanded }" *ngIf="item.sub">
          <li *ngFor="let child of item.sub" [ngClass]="{ 'has-children': child.sub }">
            <a [routerLink]="child.link ? child.link: null" [routerLinkActive]="'active'"
              (click)="toggleSubMenu(child)">
              {{ child.name }}
              <!-- <i class="material-icons" *ngIf="child.sub">{{ child.expanded ? "expand_less" : "expand_more" }}</i> -->
            </a>
            <ul [ngClass]="{ 'show-submenu': child.expanded }" *ngIf="child.sub">
              <li *ngFor="let subChild of child.sub">
                <a [routerLink]="subChild.link ? subChild.link: null" [routerLinkActive]="'active'">
                  {{ subChild.name }}
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </li>
      <div class="sidenav-margin link more" #viewMore (click)="seeLess = false; defaultListCount = allSideNav.length"
        *ngIf="seeLess">
        <div class="sidenav-box">
          <div class="dot-more">
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
          </div>
          More
        </div>
      </div>
    </ul>
  </div>
</div>
<!-- </div> -->